import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button/Button';
import Label from 'components/form/Label/Label';
import OText from 'components/CText/OText';
import classnames from 'classnames';

export const BannerCta = props => {
  const { ctaText, disclaimer, onClickCta, isTwoModules } = props;

  const wrapperClassnames = classnames({
    margTB16: !isTwoModules,
    margT16: isTwoModules,
  });
  return (
    <>
      <FlexContainer
        justifyCenter
        alignItemsCenter
        className={wrapperClassnames}
      >
        <Button
          className="padLR32"
          onClick={onClickCta}
          mrphType="primary"
          rounded
        >
          <OText text={ctaText} />
        </Button>
      </FlexContainer>
      {disclaimer && (
        <Label className="text-11 fontGray250 italic">
          <OText text={disclaimer} />
        </Label>
      )}
    </>
  );
};
